import $ from 'jquery';
import store from 'store';
import expirePlugin from 'store/plugins/expire';

const showPopup = ($el, animation, position) => {
    $('body').addClass(`js-state-popup-${position}`);

    if(animation === 'fade') {
        $el.fadeIn();
    } else if(animation === 'slide') {
        $el.slideDown();
    }
};

const hidePopup = ($el, animation, position) => {
    $('body').removeClass(`js-state-popup-${position}`);

    if(animation === 'fade') {
        $el.fadeOut();
    } else if(animation === 'slide') {
        $el.slideUp();
    }
};

const exitIntent = ($el, animation, position) => {
    const exitIntentListener = (e) => {
        const shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10;
        if (shouldShowExitIntent) {
            document.removeEventListener('mouseout', exitIntentListener);
            showPopup($el, animation, position);
        }
    };

    document.addEventListener('mouseout', exitIntentListener);
};

const initPopup = (el) => {
    const $el = $(el);

    // Activate expire plugin on init so sessions that are expired are removed
    store.addPlugin(expirePlugin);

    $el.removeClass('js-state-initial').hide();

    const cookieName = $el.data('cookie') || 'popup-closed';
    const animation = $el.data('animation') || '';
    const trigger = $el.data('trigger') || '';
    const position = $el.data('position') || '';

    const isClosed = store.get(cookieName);
    if (isClosed === undefined) {
        if(trigger == 'timeout') {
            setTimeout(() => {
                showPopup($el, animation, position);
            }, 15000);
        } else if(trigger == 'exit') {
            setTimeout(() => {
                exitIntent($el, animation, position)
            }, 15000);
        } else {
            showPopup($el, animation, position);
        }
    }

    $el.find('.js-popup-close').click(function (e) {
        e.preventDefault();
        hidePopup($el, animation, position);
        const expire = 15 * 24 * 60 * 60 * 1000; // 15 days
        store.set(cookieName, 'true', new Date().getTime() + expire);
    });
};


export default initPopup;
